import { useLanguage, useTranslation, LANGUAGES, Language } from '../context/LanguageContext';
import { useModalKeyboard } from '../hooks/useModalKeyboard';

interface LanguagePickerModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function LanguagePickerModal({ isOpen, onClose }: LanguagePickerModalProps) {
  const { language, setLanguage } = useLanguage();
  const { t } = useTranslation();
  useModalKeyboard(isOpen, onClose);

  if (!isOpen) return null;

  const handleSelect = (code: Language) => {
    setLanguage(code);
    onClose();
  };

  return (
    <div className="win98-modal-overlay" onClick={onClose}>
      <div className="win98-window win98-modal-sm" onClick={(e) => e.stopPropagation()}>
        <div className="win98-title-bar">
          <div className="win98-title">{t('common.language')}</div>
          <div className="win98-controls">
            <div className="win98-button-control" onClick={onClose}>
              <i className="fas fa-xmark" />
            </div>
          </div>
        </div>
        <div className="win98-content" style={{ padding: '12px' }}>
          <div className="win98-lang-grid">
            {LANGUAGES.map((lang) => (
              <button
                key={lang.code}
                className={`win98-button win98-lang-option ${language === lang.code ? 'win98-button-primary' : ''}`}
                onClick={() => handleSelect(lang.code)}
              >
                {lang.flag} {lang.name}
              </button>
            ))}
          </div>
          <div className="win98-text-muted win98-text-small" style={{ marginTop: '12px', textAlign: 'center' }}>
            {t('common.volunteerTranslations')}
            <div style={{ display: 'flex', justifyContent: 'center', gap: '12px', marginTop: '6px' }}>
              <a href="https://discord.gg/PgucKuGKKf" target="_blank" rel="noopener noreferrer" style={{ display: 'inline-flex', alignItems: 'center', gap: '4px' }}>
                <i className="fab fa-discord" /> Discord
              </a>
              <a href="https://x.com/minemoreapp" target="_blank" rel="noopener noreferrer" style={{ display: 'inline-flex', alignItems: 'center', gap: '4px' }}>
                <img src="/app-icons/x.svg" alt="X" style={{ width: '12px', height: '12px' }} /> @minemoreapp
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
